import LocalizedStrings from 'localized-strings';

interface SelectFromBankAccountLocales {
  fromAccount: string;
}

const locales = new LocalizedStrings<SelectFromBankAccountLocales>({
  en: {
    fromAccount: 'From your wallet',
  },
  fr: {
    fromAccount: 'Depuis votre compte',
  },
} as const);

export default locales;
